module.exports = __webpack_public_path__ + "static/img/10.e6bdcee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/front/threeD/17/10.png
// module id = Wgfr
// module chunks = 2